/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/services/authenticationservice.ts" />
/// <reference path="../../common/services/usersservice.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />

module App.Common.Controllers {
    'use strict';

    class HeaderController implements IInitialize {

		private autheticated = false;

		public signInMessage: string;
		public searchString: string;
		public api: Common.Services.ApiService;
        public busyPromise: angular.IPromise<any>;
		public showHeader = false;

        public static $inject = [
			'$q',
            '$rootScope',
            '$state',
            'app.common.services.authenticationService',
            'app.common.services.navigationHelperService',
            'app.common.services.usersService',
            'app.common.services.globalSettingsService',
			'app.common.services.apiService',
			'$uibModal',
			'app.common.services.errorHandlerService',
			'app.common.services.modalService'
        ];

        constructor(
			private $q: angular.IQService,
            private $rootScope: angular.IRootScopeService,
            private $state: angular.ui.IStateService,
            private authentication: Services.AuthenticationService,
            private navigationHelper: Services.NavigationHelperService,
            private users: Services.UsersService,
			private globalSettings: Services.GlobalSettingsService,
			private apiService: Services.ApiService,
			private $uibModal: angular.ui.bootstrap.IModalService,
			private errorHandler: Services.ErrorHandlerService,
			private modal: Services.ModalService
		) {
			//register the initializer so this initialize() method is called once authenticated
	        this.navigationHelper.registerInitializer(this);

            this.signInMessage = '';
			//subscribe to the broadcast event: this.globalSettings.broadcastEvents.authenticationComplete
			this.$rootScope.$on(this.globalSettings.broadcastEvents.authenticationComplete, data => {
				this.autheticated = true;
			});
        }

		public initialize(): angular.IPromise<any> {
			//this is called once we are 
			this.showHeader = true;
			return this.$q.resolve();
		}

		public showHomeLink(): boolean {
            return !this.navigationHelper.currentScreenIsSignIn()
				&& !this.navigationHelper.currentScreenIsHome();
        }

        public showSignIn(): boolean {
			return !this.navigationHelper.currentScreenIsSignIn();
        }

        public getCurrentUserFullName(): string {
            return this.users.getCurrentUser().fullName || '';
        }

        public isFullyAuthenticated(): boolean {
            return this.authentication.isAuthenticated() && !!this.getCurrentUserFullName();
        }

        public useWindowsAuthentication(): boolean {
            return this.authentication.useWindowsAuthentication();
        }

		public canSignIn(): boolean {
            return !this.useWindowsAuthentication() && !this.isFullyAuthenticated();
        }

        public canSignOut(): boolean {
            return !this.useWindowsAuthentication() && this.isFullyAuthenticated();
        }

        public signOut() {
            this.authentication.signOut();
        }

	    public search(): void {
			var config = new MessageBoxConfig(
				'Search Result',
				this.searchString,
				[Common.DialogOutcome.ok],
				true,
				true
			);
			this.modal.open(config);
	    }

    }

    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.headerController', HeaderController);
}